import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { API_BASE_URL } from '../config/apiConfig';
import { DEFAULT_ENTRY_HELP } from '../constants/helpText';
import { shareBackup } from '../utils/localBackup';

const EntryHelpButton = ({
  buttonLabel = 'Hilfe',
  buttonClassName = 'btn btn-secondary',
  buttonStyle = {},
  tenant = null,
  user = null
}) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasFetched, setHasFetched] = useState(false);

  const fetchHelpText = async () => {
    setLoading(true);
    setError('');
    try {
      const headers = { 'Content-Type': 'application/json' };
      if (tenant) {
        headers['X-Tenant-Key'] = tenant;
      }
      const response = await fetch(`${API_BASE_URL}/help/entry`, { headers });
      if (!response.ok) {
        throw new Error('Hilfetext konnte nicht geladen werden.');
      }
      const data = await response.json();
      setContent(data.content || DEFAULT_ENTRY_HELP);
    } catch (err) {
      console.error('Hilfetext konnte nicht geladen werden:', err);
      setContent(DEFAULT_ENTRY_HELP);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  const openModal = () => {
    if (!hasFetched) {
      fetchHelpText();
    }
    setOpen(true);
  };

  const closeModal = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        style={buttonStyle}
        onClick={openModal}
      >
        {buttonLabel}
      </button>
      {open && (
        <div className="help-modal-overlay" onClick={closeModal}>
          <div className="help-modal" onClick={(e) => e.stopPropagation()}>
            <div className="help-modal-header">
              <h3>Hilfe</h3>
              <button
                type="button"
                className="help-modal-close"
                onClick={closeModal}
                aria-label="Fenster schließen"
              >
                ×
              </button>
            </div>
            <div className="help-modal-body">
              {loading && <div>Hilfetext wird geladen...</div>}
              {!loading && (
                <>
                  {error && <div className="error-message">{error}</div>}
                  <ReactMarkdown>{content || DEFAULT_ENTRY_HELP}</ReactMarkdown>
                </>
              )}
              {user && (
                <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #e0e0e0' }}>
                  <button
                    onClick={() => shareBackup(user.tenant || user.database, user.mitid)}
                    className="btn btn-secondary"
                    style={{ width: '100%', fontSize: '14px' }}
                  >
                    Lokales Backup senden
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EntryHelpButton;

